import styled from 'styled-components';

export const MainContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FFF;
  min-width: 400px;
  max-width: 90%;
  padding: 2rem;
`;